export const SMALL_SCREEN = 1024
export const SESSION_TIMEOUT = 28 * 60 * 1000

export const GRAPHQL_PATH = '/graphql'
